__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "16.2.12", () => (() => (__webpack_require__(3761))), 1);
			register("@angular/cdk", "16.2.14", () => (() => (__webpack_require__(9987))), 1);
			register("@angular/common", "16.2.12", () => (() => (__webpack_require__(1761))), 1);
			register("@angular/core", "16.2.12", () => (() => (__webpack_require__(6489))), 1);
			register("@angular/forms", "16.2.12", () => (() => (__webpack_require__(4665))), 1);
			register("@angular/router", "16.2.12", () => (() => (__webpack_require__(9311))), 1);
			register("exceljs", "4.4.0", () => (() => (__webpack_require__(6165))), 1);
			register("file-saver", "2.0.5", () => (() => (__webpack_require__(4148))), 1);
			register("moment", "2.29.4", () => (() => (__webpack_require__(9580))), 1);
			register("ngx-daterangepicker-material", "6.0.4", () => (() => (__webpack_require__(693))), 1);
			register("tslib", "2.8.1", () => (() => (__webpack_require__(7701))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};